var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54688 14.875H10.3906C10.6016 14.875 10.8125 14.6992 10.8125 14.4531V6.85938C10.8125 6.64844 10.6016 6.4375 10.3906 6.4375H9.54688C9.30078 6.4375 9.125 6.64844 9.125 6.85938V14.4531C9.125 14.6992 9.30078 14.875 9.54688 14.875ZM15.3125 3.0625H12.3945L11.1992 1.09375C10.918 0.601562 10.3555 0.25 9.75781 0.25H6.20703C5.60938 0.25 5.04688 0.601562 4.76562 1.09375L3.57031 3.0625H0.6875C0.371094 3.0625 0.125 3.34375 0.125 3.625V4.1875C0.125 4.50391 0.371094 4.75 0.6875 4.75H1.25V16.5625C1.25 17.5117 1.98828 18.25 2.9375 18.25H13.0625C13.9766 18.25 14.75 17.5117 14.75 16.5625V4.75H15.3125C15.5938 4.75 15.875 4.50391 15.875 4.1875V3.625C15.875 3.34375 15.5938 3.0625 15.3125 3.0625ZM6.13672 2.04297C6.17188 2.00781 6.24219 1.9375 6.3125 1.9375C6.3125 1.9375 6.3125 1.9375 6.34766 1.9375H9.65234C9.72266 1.9375 9.79297 2.00781 9.82812 2.04297L10.4258 3.0625H5.53906L6.13672 2.04297ZM13.0625 16.5625H2.9375V4.75H13.0625V16.5625ZM5.60938 14.875H6.45312C6.66406 14.875 6.875 14.6992 6.875 14.4531V6.85938C6.875 6.64844 6.66406 6.4375 6.45312 6.4375H5.60938C5.36328 6.4375 5.1875 6.64844 5.1875 6.85938V14.4531C5.1875 14.6992 5.36328 14.875 5.60938 14.875Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlack);
export default __webpack_public_path__ + "static/media/delete-black.37c2b271c7b1fe578770f9e3d8dda63b.svg";
export { ForwardRef as ReactComponent };